import { create, StateCreator } from 'zustand'
import { devtools, persist, createJSONStorage } from 'zustand/middleware'

import { IAppSessionState } from './appStore.types'
import { ORIGIN_SEARCH_PARAMS } from '../config/searchParams'


const initialState: IAppSessionState = {
    searchParams: {
        access_token: null,
        refresh_token: null,
        login_origin_domain: null,
        signup_origin_domain: null,
        signup_origin_path: null,
    },
    showGlobalAlert: undefined,
}

export interface IAppSessionStore extends IAppSessionState {
    setSearchParams: (searchParams: Partial<IAppSessionState['searchParams']>) => void
    setShowGlobalAlert: (showGlobalAlert: boolean) => void
    clearOriginParams: () => void

    reset: () => void
}

const createAppSessionStore: StateCreator<
    IAppSessionStore,
    [['zustand/persist', unknown], ['zustand/devtools', never]]
> = (set) => ({
    ...initialState,
    setSearchParams: (searchParams: Partial<IAppSessionState['searchParams']>) =>
        set(
            (state) => ({
                searchParams: {
                    ...state.searchParams,
                    ...searchParams,
                },
            }),
            undefined,
            'appSessionStore/setSearchParams'
        ),
    setShowGlobalAlert: (showGlobalAlert: boolean) =>
        set({ showGlobalAlert }, undefined, 'appSessionStore/setShowGlobalAlert'),
    clearOriginParams: () =>
        set(
            (state) => ({
                searchParams: {
                    ...state.searchParams,
                    ...Object.fromEntries(ORIGIN_SEARCH_PARAMS.map((key) => [key, null])),
                },
            }),
            undefined,
            'appSessionStore/clearOriginParams'
        ),
    
    reset: () => set({ ...initialState }, undefined, 'appSessionStore/reset'),
})

const useAppSessionStore = create<IAppSessionStore>()(
    persist(
        devtools(createAppSessionStore, { name: 'AppSessionStore' }),
        {
            name: 'app-session-store',
            storage: createJSONStorage(() => sessionStorage),
        }
    )
)

export default useAppSessionStore
